import React, { useState } from "react";
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { auth } from "../../firebase/firebase";

function RegisterPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const validatePassword = (password) => {
    return /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/.test(password) && !password.includes(" ");
  };

  const getPasswordStrength = () => {
    const length = password.length;
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);

    if (length >= 8 && hasUppercase && hasNumber) return "strong";
    if (length >= 6 && (hasUppercase || hasNumber)) return "medium";
    return "weak";
  };

  const getStrengthColor = () => {
    const strength = getPasswordStrength();
    switch (strength) {
      case "strong":
        return "bg-success";
      case "medium":
        return "bg-warning";
      default:
        return "bg-danger";
    }
  };

  const passwordCriteria = {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasNumber: /\d/.test(password),
    noSpaces: !password.includes(" "),
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    if (!email || !password || !confirmPassword) {
      setError("Bitte fülle alle Felder aus.");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError("Die Passwörter stimmen nicht überein.");
      setLoading(false);
      return;
    }

    if (!validatePassword(password)) {
      setError("Das Passwort erfüllt nicht die Mindestanforderungen.");
      setLoading(false);
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await sendEmailVerification(userCredential.user);
      setMessage("Registrierung erfolgreich. Bitte bestätige deine E-Mail.");
    } catch (err) {
      setError("Fehler: " + err.message);
    }

    setLoading(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="modal-content rounded-4 shadow" style={{ width: "400px" }}>
        <div className="modal-header p-5 pb-4 border-bottom-0">
          <h1 className="fw-bold mb-0 fs-2">Registrieren</h1>
        </div>

        <div className="modal-body p-5 pt-0">
          <form onSubmit={handleRegister}>
            <div className="form-floating mb-3">
              <input 
                type="email" 
                className="form-control rounded-3"
                id="floatingEmail" 
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="floatingEmail">E-Mail-Adresse</label>
            </div>

            <div className="form-floating mb-1">
              <input 
                type={showPassword ? "text" : "password"}
                className="form-control rounded-3"
                id="floatingPassword" 
                placeholder="Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label htmlFor="floatingPassword">Passwort</label>
            </div>

            {/* Passwort Toggle */}
            <div className="form-check mb-2">
              <input 
                type="checkbox"
                className="form-check-input"
                id="showPassword"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              />
              <label className="form-check-label" htmlFor="showPassword">
                Passwort anzeigen
              </label>
            </div>

            {/* Ampelanzeige */}
            <div className="progress mb-2" style={{ height: "6px" }}>
              <div
                className={`progress-bar ${getStrengthColor()}`}
                role="progressbar"
                style={{ width: "100%" }}
              ></div>
            </div>

            {/* Kriterienliste */}
            <div className="mb-3 small">
              <p className="mb-1">Passwort muss enthalten:</p>
              <ul className="list-unstyled mb-0 ps-3">
                <li className={passwordCriteria.minLength ? "text-success" : "text-danger"}>
                  {passwordCriteria.minLength ? "✔" : "✘"} Mindestens 8 Zeichen
                </li>
                <li className={passwordCriteria.hasUppercase ? "text-success" : "text-danger"}>
                  {passwordCriteria.hasUppercase ? "✔" : "✘"} Mindestens ein Großbuchstabe
                </li>
                <li className={passwordCriteria.hasNumber ? "text-success" : "text-danger"}>
                  {passwordCriteria.hasNumber ? "✔" : "✘"} Mindestens eine Zahl
                </li>
                <li className={passwordCriteria.noSpaces ? "text-success" : "text-danger"}>
                    {passwordCriteria.noSpaces ? "✔" : "✘"} Keine Leerzeichen enthalten
                </li>
              </ul>
            </div>

            <div className="form-floating mb-3">
              <input 
                type={showPassword ? "text" : "password"}
                className="form-control rounded-3"
                id="floatingConfirmPassword" 
                placeholder="Passwort wiederholen"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <label htmlFor="floatingConfirmPassword">Passwort wiederholen</label>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}

            <button className="w-100 btn btn-lg rounded-3 btn-primary" type="submit" disabled={loading}>
              {loading ? "Wird erstellt..." : "Konto erstellen"}
            </button>

            <div className="text-center mt-3">
              <a href="/login" className="text-decoration-none">Zurück zum Login</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
